import React from 'react';
import { object } from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import Tooltip from 'ravenjs/lib/Tooltip';
import Button from 'ravenjs/lib/Button';
import Row from 'ravenjs/lib/Row';

import { USER_LOOKUP } from 'constants/tickets';
import { APP_PERMISSIONS } from 'constants/permissions';
import { AddIcon, EditIcon, ViewDocumentIcon } from 'components/Icons';
import Acl from 'modules/acl';

const NavLinkStyled = styled(NavLink)`
    & {
        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    }
`;

function ActionIcons({ row, handlers }) {
    const hasNoCreateCasePermission = !Acl.check(
        APP_PERMISSIONS.systemCaseCaveCreateCaseForInactiveUser
    );
    const disableCreateCaseButton = hasNoCreateCasePermission;

    return (
        <Row margin="0">
            <Tooltip content={USER_LOOKUP.TOOLTIPS.SHOW_DETAILS}>
                <Button
                    data-testid="view-document-button"
                    noMinWidth
                    color="primaryTransparent"
                    onClick={() => handlers.handleAdditionalDetails({ row })}
                >
                    <ViewDocumentIcon />
                </Button>
            </Tooltip>
            <Tooltip content={USER_LOOKUP.TOOLTIPS.EDIT_USER}>
                <Button
                    data-testid="edit-button"
                    noMinWidth
                    color="primaryTransparent"
                    onClick={() => handlers.handleEditUser({ row })}
                >
                    <EditIcon />
                </Button>
            </Tooltip>
            <Tooltip
                content={
                    disableCreateCaseButton
                        ? USER_LOOKUP.TOOLTIPS.IN_ACTIVE_USER
                        : USER_LOOKUP.TOOLTIPS.CREATE_CASE
                }
            >
                <NavLinkStyled
                    to={handlers.handleCreateTicket({ row })}
                    disabled={disableCreateCaseButton}
                    onContextMenu={event => {
                        if (disableCreateCaseButton) {
                            event.preventDefault();
                        }
                    }}
                >
                    <Button
                        data-testid="add-button"
                        noMinWidth
                        color="secondary"
                        disabled={disableCreateCaseButton}
                    >
                        <AddIcon />
                    </Button>
                </NavLinkStyled>
            </Tooltip>
        </Row>
    );
}

ActionIcons.propTypes = {
    row: object,
    handlers: object,
};

ActionIcons.defaultProps = {
    row: {},
    handlers: {
        handleAdditionalDetails: () => {},
        handleEditUser: () => {},
        handleCreateTicket: () => {},
    },
};

export default ActionIcons;
